import crudFactory from "../crudFactory.ts";
import { DND_SUMMARY_TILES_MODEL } from "@/features/demurrage-detention/constants";

const COMMON_CRUD_APIs = crudFactory(DND_SUMMARY_TILES_MODEL);

export default { ...COMMON_CRUD_APIs };
